(function () {
  'use strict';

  var POLL_INTERVAL = 250;
  var MAX_WAIT = 6000;

  function isOnlineLocation(loc) {
    if (!loc) return false;
    // The app's "online store" pseudo-location carries no physical address
    // or coordinates — every real store location does. This is how we tell
    // the warehouse apart from a shop without hardcoding a location id.
    return !loc.latitude && !(loc.address1 && loc.address1.length);
  }

  function computeState(entry, market) {
    if (!entry || !entry.inventoryLocations) return null;

    var onlineQty = 0;
    var storeQty = 0;
    var storeNames = [];

    entry.inventoryLocations.forEach(function (item) {
      var qty = Math.max(0, item.quantity || 0);
      var location = item.location;
      if (isOnlineLocation(location)) {
        onlineQty += qty;
      } else if (location && location.countryCode === market) {
        storeQty += qty;
        if (qty > 0) storeNames.push(location.name);
      }
    });

    return { onlineQty: onlineQty, storeQty: storeQty, storeNames: storeNames };
  }

  function render(container, strings, state) {
    if (!state) return; // fail open: leave Shopify's native state untouched

    var label;
    var note = '';

    if (state.onlineQty >= 1) {
      container.className = 'availability-state availability-state--online';
      label = strings.online;
    } else if (state.storeQty >= 1) {
      container.className = 'availability-state availability-state--store-only';
      label = strings.store_only;
      if (state.storeNames.length) note = strings.store_only_at.replace('{location}', state.storeNames.join(', '));
    } else {
      container.className = 'availability-state availability-state--unavailable';
      label = strings.unavailable;
    }

    container.innerHTML =
      '<strong class="availability-state__label">' + label + '</strong>' +
      (note ? '<p class="availability-state__note">' + note + '</p>' : '');
    container.hidden = false;
  }

  function findEntry(handle, variantId) {
    var info = window.inventoryInfo;
    if (!info || !info[handle] || !info[handle].data) return null;
    var list = info[handle].data.variantLocations;
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].variant) === String(variantId)) return list[i];
    }
    return null;
  }

  function readStrings(container) {
    var node = document.getElementById(container.dataset.stringsId);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  // Fallback when the Multi-Location Inv. app is not installed (e.g. the
  // Swedish store): use the Flow-maintained custom.variant_store_only
  // metafield ({variant_id: {se: bool, fi: bool, ...}}). It only knows the
  // "store only" case, so anything else stays hidden (fail open).
  function readStoreOnlyMap(container) {
    if (!container.dataset.storeOnlyMap) return null;
    try {
      return JSON.parse(container.dataset.storeOnlyMap);
    } catch (e) {
      return null;
    }
  }

  function fallbackState(container, variantId) {
    var map = readStoreOnlyMap(container);
    var key = container.dataset.marketKey;
    if (!map || !key || !map[String(variantId)]) return null;
    if (map[String(variantId)][key] === true) {
      var stores = map[String(variantId)].stores || {};
      var names = Object.keys(stores).filter(function (n) { return stores[n] > 0; });
      return { onlineQty: 0, storeQty: 1, storeNames: names, fallback: true };
    }
    return null;
  }

  // Store availability drawer.
  //
  // Preferred source: the Multi-Location Inv. app's window.inventoryInfo,
  // which lists every store's quantity, address and phone per variant
  // (yeppo.fi, FI and DE markets). The list is built client-side from the
  // row <template> in the snippet, restricted to the buyer's market.
  //
  // Fallback (yepposoonsoo.se, no app): the snippet renders a static store
  // list that is filled from the custom.variant_store_only metafield map.
  //
  // The opener link is only shown when there is something to show.
  function appStores(handle, market, variantId) {
    var info = window.inventoryInfo;
    if (!info || !info[handle] || !info[handle].data || !info[handle].data.variantLocations) return null;

    var byName = {};
    info[handle].data.variantLocations.forEach(function (entry) {
      (entry.inventoryLocations || []).forEach(function (item) {
        var loc = item.location;
        if (!loc || isOnlineLocation(loc) || loc.countryCode !== market) return;
        if (!byName[loc.name]) {
          byName[loc.name] = {
            name: loc.name,
            lines: [loc.address1 || '', [loc.zip, loc.city].filter(Boolean).join(' ')].filter(Boolean),
            phone: loc.phone || '',
            order: typeof loc.displayOrder === 'number' ? loc.displayOrder : 9999,
            qty: 0
          };
        }
        if (String(entry.variant) === String(variantId)) {
          byName[loc.name].qty = Math.max(0, item.quantity || 0);
        }
      });
    });

    var stores = Object.keys(byName).map(function (n) { return byName[n]; });
    stores.sort(function (a, b) { return (a.order - b.order) || a.name.localeCompare(b.name); });
    return stores.length ? stores : null;
  }

  function setStatus(item, strings, qty) {
    var inStock = qty > 0;
    item.querySelector('[data-store-icon="in"]').hidden = !inStock;
    item.querySelector('[data-store-icon="out"]').hidden = inStock;
    item.querySelector('[data-store-status]').textContent = inStock
      ? strings.in_stock_qty.replace('{count}', qty)
      : strings.out_of_stock;
  }

  function buildStoreList(drawer, strings, stores) {
    var list = drawer.querySelector('[data-store-list]');
    var template = drawer.querySelector('[data-store-template]');
    if (!list || !template) return false;

    list.querySelectorAll('[data-store-dynamic]').forEach(function (el) { el.remove(); });

    stores.forEach(function (store, index) {
      var item = template.content.firstElementChild.cloneNode(true);
      item.dataset.storeName = store.name;
      if (index === 0) {
        var hr = item.querySelector('hr');
        if (hr) hr.remove();
      }
      item.querySelector('[data-store-title]').textContent = store.name;

      var address = item.querySelector('[data-store-address]');
      store.lines.forEach(function (line, i) {
        if (i > 0) address.appendChild(document.createElement('br'));
        address.appendChild(document.createTextNode(line));
      });

      if (store.phone) {
        item.querySelector('[data-store-phone]').textContent = store.phone;
        item.querySelector('[data-store-phone-row]').hidden = false;
      }

      setStatus(item, strings, store.qty);
      list.appendChild(item);
    });
    return true;
  }

  // Shopify's own pickup-availability drawer (FI): the theme's
  // pickup-availability snippets carry an empty [data-pickup-stock] line per
  // store, filled here with the variant's quantity from the app data. The
  // drawer is re-rendered on every variant change, so this runs again from
  // the on:variant:change handler (fired after the new markup is in place).
  function fillPickupStock(container, strings, variantId) {
    var nodes = document.querySelectorAll('[data-pickup-stock]');
    if (!nodes.length) return false;

    var entry = findEntry(container.dataset.productHandle, variantId);
    if (!entry || !entry.inventoryLocations) return true;

    // Only the buyer's own market: Shopify lists the Finnish pickup stores on
    // every market (e.g. yepposoonsoo.de), and those must not get quantities
    // there. If nothing matches, the caller falls back to the custom drawer.
    var market = (container.dataset.market || '').toUpperCase();
    var qtyByName = {};
    entry.inventoryLocations.forEach(function (item) {
      var loc = item.location;
      if (loc && loc.name && loc.countryCode === market) qtyByName[loc.name] = Math.max(0, item.quantity || 0);
    });

    var filled = 0;
    nodes.forEach(function (node) {
      var name = node.dataset.locationName;
      if (!(name in qtyByName)) return; // not this market / no data: leave the line hidden
      var qty = qtyByName[name];
      node.textContent = qty > 0 ? strings.in_stock_qty.replace('{count}', qty) : strings.out_of_stock;
      node.hidden = false;
      filled += 1;
    });
    return filled > 0;
  }

  function renderStores(container, strings, variantId, variantTitle) {
    var opener = container.parentNode.querySelector('[data-availability-stores]');
    var drawer = container.parentNode.querySelector('side-drawer[data-name="store-availability"]');
    if (!opener || !drawer) return;

    // Where Shopify's native pickup drawer exists (FI stores offer pickup),
    // show the quantities inside it instead of a second drawer.
    if (fillPickupStock(container, strings, variantId)) {
      opener.hidden = true;
      return;
    }

    var market = (container.dataset.market || '').toUpperCase();
    var stores = appStores(container.dataset.productHandle, market, variantId);
    var shown = false;

    if (stores) {
      shown = buildStoreList(drawer, strings, stores);
    } else {
      var map = readStoreOnlyMap(container);
      var entry = map && map[String(variantId)];
      var staticItems = drawer.querySelectorAll('[data-store-name]:not([data-store-dynamic])');
      if (entry && staticItems.length) {
        var qtys = entry.stores || {};
        staticItems.forEach(function (item) {
          setStatus(item, strings, qtys[item.dataset.storeName] || 0);
        });
        shown = true;
      }
    }

    if (!shown) {
      opener.hidden = true;
      return;
    }

    if (!variantTitle) {
      try {
        var titles = JSON.parse(drawer.dataset.variantTitles || '{}');
        variantTitle = titles[String(variantId)];
      } catch (err) { variantTitle = null; }
    }
    var titleEl = drawer.querySelector('[data-store-variant-title]');
    if (titleEl && variantTitle) titleEl.textContent = variantTitle;

    opener.hidden = false;
  }

  function init(container) {
    var handle = container.dataset.productHandle;
    var market = (container.dataset.market || '').toUpperCase();
    var strings = readStrings(container);
    if (!strings) return;

    renderStores(container, strings, container.dataset.variantId);

    // Stores without the inventory app (e.g. Sweden) have no window.inventoryInfo
    // to wait for: show the metafield fallback right away and let the app's
    // richer data replace it if it ever arrives.
    var initialFallback = fallbackState(container, container.dataset.variantId);
    if (initialFallback) render(container, strings, initialFallback);

    var waited = 0;
    var timer = setInterval(function () {
      waited += POLL_INTERVAL;
      var entry = findEntry(handle, container.dataset.variantId);
      if (entry) {
        clearInterval(timer);
        render(container, strings, computeState(entry, market));
        renderStores(container, strings, container.dataset.variantId);
      } else if (waited >= MAX_WAIT) {
        clearInterval(timer);
        // The app's data never showed up — keep/apply the metafield fallback,
        // otherwise leave the native state as-is.
        if (!initialFallback) render(container, strings, fallbackState(container, container.dataset.variantId));
      }
    }, POLL_INTERVAL);

    var update = function (variantId, variantTitle) {
      container.dataset.variantId = variantId;
      renderStores(container, strings, variantId, variantTitle);
      var entry = findEntry(handle, variantId);
      if (entry) {
        render(container, strings, computeState(entry, market));
      } else {
        var fb = fallbackState(container, variantId);
        if (fb) {
          render(container, strings, fb);
        } else {
          container.hidden = true;
        }
      }
    };

    // Beautify fires on:variant:change ~10 ms after it has swapped the
    // variant-dependent markup (price, pickup drawer, ...) into the page.
    document.addEventListener('on:variant:change', function (e) {
      if (e.detail && e.detail.variant) update(e.detail.variant.id, e.detail.variant.title);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') update(e.target.value);
    });
  }

  document.querySelectorAll('[data-availability-state]').forEach(init);
})();
